import type { FeaturevisorInstance } from '@featurevisor/sdk';
import type { OrganizationContextSchemaT } from '../contexts/organization-context';

export const ToolsPaymentFeature = (
  sdk: FeaturevisorInstance,
  context: OrganizationContextSchemaT
) => {
  const key = 'tools-payment';

  const isEnabled = sdk.isEnabled(key, context);

  return {
    key,
    isEnabled,
  };
};
